/* script */
//
//
//
//
//
//
//
//
//
//
//
//

// Utils
import { get, set } from 'lodash';

// Components
import AppsPreview from 'ui/components/theme/AppsPreview.vue';
import LoaderButton from 'shared/ui/components/form-components/LoaderButton.vue';
import MainForm from 'ui/components/theme/MainForm.vue';

const __vue_script__ = {
    name: 'ThemeManager',

    components: {
        AppsPreview,
        LoaderButton,
        MainForm
    },

    props: {
        params: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            saving: false,
            ready: false,
            theme: null,
            preview: 'web'
        };
    },

    computed: {
        form() {
            if (!this.theme) {
                return {};
            }

            const form = {};
            for (const [prop, { paths, defaultValue }] of Object.entries(this.$services.theme.V2_THEME_MAPPING)) {
                paths.forEach(path => form[prop] = get(this.theme, path, defaultValue));
            }

            return form;
        }
    },

    async created() {
        try {
            const eid = this.params.event._id;
            this.theme = await this.$services.theme.getTheme(eid);

        } catch (error) {
            console.error('[ThemeManager] Could not load the theme', error.message);
        } finally {
            this.ready = true;
        }
    },

    methods: {
        updateTheme(form) {
            for (const [prop, { paths, defaultValue }] of Object.entries(this.$services.theme.V2_THEME_MAPPING)) {
                paths.forEach(path => set(this.theme, path, form.hasOwnProperty(prop) ? form[prop] : get(this.theme, path, defaultValue)));
            }

            console.debug('[ThemeManager] Theme changed', this.theme);
        },

        navigateToThemeWizard() {
            this.$modal.show('dialog', {
                title: this.$t('general.warning'),
                text: this.$t('theme.editor.messages.wizard_warn'),
                buttons: [
                    {
                        title: this.$t('general.cancel'),
                        default: true,
                        class: 'btn'
                    },
                    {
                        title: this.$t('general.continue'),
                        handler: async () => {
                            this.$router.push(`/event/${this.params.event._id}/modules/theme-editor/wizard`);
                            this.$modal.hide('dialog');
                        },
                        class: 'btn btn-primary'
                    }
                ]
            });
        },

        async refreshTheme() {
            this.theme = await this.$services.theme.refresh(this.params.event._id);
        },

        async save() {
            try {
                if (this.saving) return;
                this.saving = true;

                const valid = await this.$refs.form.validate();
                if (!valid) {
                    console.warn('[ThemeManager] Form contains invalid data');
                    return;
                }

                const event = this.params.event;
                const doc = await this.$services.theme.buildBitForSave(event._id, this.theme);
                console.info('[ThemeManager] Saving theme', doc);
                const upsert = doc._rev ? 'updateDoc' : 'createDocs';
                await this.$services.documents[upsert](event._id, event.node, this.$services.theme.THEME_BIT_TYPE, doc, { keepId: true });
                this.refreshTheme();

                this.$notify({
                    group: 'flashes',
                    text: this.$i18n.t('theme.editor.messages.save_success').toString(),
                    type: 'success',
                });
            } catch (error) {
                console.error('[ThemeManager] Could not save the theme', error.message);

                this.$notify({
                    group: 'flashes',
                    title: this.$i18n.t('general.error_occurred').toString(),
                    text: this.$i18n.t('theme.editor.messages.save_failed').toString(),
                    type: 'error',
                });
            } finally {
                this.saving = false;
            }
        }
    }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.ready)?_c('div',{staticClass:"theme-manager"},[(_vm.theme)?_c('main-form',{ref:"form",attrs:{"theme":_vm.form},on:{"change":_vm.updateTheme}}):_vm._e(),(_vm.theme)?_c('apps-preview',{attrs:{"event":_vm.params.event,"theme":_vm.theme}}):_vm._e(),_c('secondary-toolbar',{scopedSlots:_vm._u([{key:"contextual",fn:function(ref){return [_c('a',{staticClass:"btn",on:{"click":function($event){return _vm.navigateToThemeWizard()}}},[_vm._v(_vm._s(_vm.$t('theme.editor.actions.quick_setup')))])]}}],null,false,1409703767)},[_c('loader-button',{staticClass:"primary",attrs:{"disabled":_vm.saving,"status":_vm.saving},on:{"click":function($event){return _vm.save()}}},[_vm._v(_vm._s(_vm.$t('general.save')))])],1)],1):_vm._e()}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "ThemeManager.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__